import { type ApiKey } from '../../../../types/apiTypes';

export type LoadingStatus = 'INITIAL' | 'LOADING' | 'SUCCESS' | 'ERROR';

export type FormActionType = 'CREATE' | 'EDIT';

export interface NewApiKey extends Omit<ApiKey, 'id' | 'created_at' | 'updated_at'> {}

export interface UpdateApiKey extends Omit<ApiKey, 'created_at' | 'updated_at'> {}

export enum ApiKeyScope {
    ATTENDANCE_READ = 'attendance:read',
    CLASS_READ = 'class:read',
    CLASS_WRITE = 'class:write',
    ENROLLMENT_READ = 'enrollment:read',
    ENROLLMENT_WRITE = 'enrollment:write',
    METRICS_READ = 'metrics:read',
    SCHEDULE_READ = 'schedule:read',
    SCHEDULE_WRITE = 'schedule:write',
    TEMPLATE_READ = 'template:read',
    TEMPLATE_WRITE = 'template:write',
    USER_READ = 'user:read',
    USER_WRITE = 'user:write'
}

export enum ExpirationTimeSelectValues {
    ONE_MONTH = 0,
    THREE_MONTHS = 1,
    SIX_MONTHS = 2,
    TWELVE_MONTHS = 3,
    NO_EXPIRATION = 4
}
